export const ASSET_TAG_PREFIX = "FF-A:";

const ASSET_TAG = /^FF-A:[A-Za-z0-9-]{1,32}$/;

/** A tag we issued; anything else (a foreign QR code, a blank tag) is not an asset. */
export function isValidAssetTag(tag: string): boolean {
  return ASSET_TAG.test(tag);
}
